import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {VisitPlanModel} from "../../../models/visit-plan.model";
import {VisitScheduleOverviewReportModel} from "../../../models/visit-schedule-overview.model";

require('./visit-plan-info-tooltip.scss');
@Component({
  standalone: false,
  selector: 'app-visit-plan-info-tooltip',
  templateUrl: './visit-plan-info-tooltip.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VisitPlanInfoTooltipComponent {

  // Either model can be passed; the template reads whichever of their fields is present.
  @Input() visitPlan: Partial<VisitPlanModel> & Partial<VisitScheduleOverviewReportModel>;

  constructor() {}

}
